<div class="comments-page">
  <app-loading-spinner [isLoading]="isSubmitting()" text="Adding comment…"></app-loading-spinner>
  <!-- Mobile View: Navigation bar with back button -->
  <nav class="comments-navbar mobile-view">
    <button class="chev" type="button" (click)="goBack()" aria-label="Back">
      <img src="/assets/images/Expand_Chevron.png" class="rot90" alt="Back">
    </button>
    <div class="nav-title">{{ title }}</div>
  </nav>

  <div class="comments-content">
    <div class="comments-scroll-area">
      <!-- Desktop View: Header with title and close button - INSIDE scroll area for sticky positioning -->
      <div class="comments-desktop-header desktop-view">
        <button class="desktop-close-button" type="button" (click)="onClose()" aria-label="Close">
          <span>&times;</span>
        </button>
        <h1 class="desktop-comments-title">{{ title }}</h1>
      </div>

      <!-- Desktop: Passport details card - pinned below header - INSIDE scroll area -->
      <section class="details-card desktop-sticky-card" *ngIf="header">
        <div class="card-line1">
          <span class="load-number">{{ headerLoadNumber }}</span>
        </div>
        <div class="card-line2">
          <img class="meta-icon" src="/assets/images/Plant_Variety.png" alt="Variety">
          <span class="meta-text variety">{{ headerVariety }}</span>
          <span class="meta-sep" aria-hidden="true"></span>
          <img class="meta-icon" src="/assets/images/Truck.png" alt="Haulier">
          <span class="meta-text haulier">{{ headerHaulier }}</span>
        </div>
        <div class="card-line3">
          <img class="sched-icon" src="/assets/images/Calendar_Passport.png" alt="Calendar">
          <span class="sched-label">Scheduled Delivery - </span>
          <span class="sched-value">{{ headerScheduled }}</span>
        </div>
      </section>
      <!-- Mobile: Passport details card - scrolls with content -->
      <section class="details-card mobile-details-card" *ngIf="header">
        <div class="card-line1">
          <span class="load-number">{{ headerLoadNumber }}</span>
        </div>
        <div class="card-line2">
          <img class="meta-icon" src="/assets/images/Plant_Variety.png" alt="Variety">
          <span class="meta-text variety">{{ headerVariety }}</span>
          <span class="meta-sep" aria-hidden="true"></span>
          <img class="meta-icon" src="/assets/images/Truck.png" alt="Haulier">
          <span class="meta-text haulier">{{ headerHaulier }}</span>
        </div>
        <div class="card-line3">
          <img class="sched-icon" src="/assets/images/Calendar_Passport.png" alt="Calendar">
          <span class="sched-label">Scheduled Delivery - </span>
          <span class="sched-value">{{ headerScheduled }}</span>
        </div>
      </section>

      <section class="comments-section">
        <div *ngIf="isLoading(); else listTpl" class="loading">Loading…</div>
        <ng-template #listTpl>
          <div #listContainer class="comments-list" *ngIf="comments().length; else emptyTpl">
            <div class="comment-item" *ngFor="let c of comments()">
              <div class="comment-header">
                <span class="comment-name">{{ c.employeeName || c.username || c.userName || 'User' }}</span><span *ngIf="c.userRole || c.persona">, </span>
                <span class="comment-persona" *ngIf="c.userRole || c.persona">{{ c.userRole || c.persona }}</span>
              </div>
              <div class="comment-date">{{ (c.createdAt || c.createdOn) | dateWithOrdinal }}</div>
              <div class="comment-message">"{{ c.message || c.commentText }}"</div>
              <div class="comment-separator"></div>
            </div>
            <div #listBottom class="list-bottom-spacer"></div>
          </div>
          <ng-template #emptyTpl>
            <div class="empty-comments">
              <div class="empty-circle">
                <img class="empty-icon" src="/assets/images/No_Comments.png" alt="No comments">
              </div>
              <div class="empty-title">No Comments Yet</div>
            </div>
          </ng-template>
        </ng-template>
      </section>
    </div>

    <div class="comments-input-wrapper" *ngIf="!readOnly">
      <form class="comment-input-bar" [class.disabled]="!isOnline()" (click)="handleBarTap($event)" (touchstart)="handleBarTap($event)" (keydown)="handleBarTap($event)" (ngSubmit)="addComment()">
        <label for="comment-input" class="sr-only">Add a comment</label>
        <input id="comment-input" class="comment-input" type="text" name="message" [ngModel]="newMessage()" (ngModelChange)="newMessage.set($event)" placeholder="Add a comment..." [disabled]="!isOnline() || isSubmitting()" autocomplete="off">
        <button class="send-btn" type="submit" [disabled]="!isOnline() || isSubmitting() || !newMessage().trim()" [attr.aria-busy]="isSubmitting()" [attr.aria-label]="sendCommentButtonAriaLabel()">
          <img class="send-icon" src="/assets/images/Send_Message.png" alt="" aria-hidden="true">
        </button>
        <div class="offline-msg" *ngIf="offlineTipVisible()">Comments can only be sent when you are online</div>
      </form>
    </div>
  </div>
</div>


